import {NavLink, useNavigate} from "react-router-dom";
import {useContext, useEffect} from "react";
import AuthContext from "../context/AuthContext";
import Footer from "../components/Footer"
import BreadCrumbs from "../components/BreadCrumbs";


export default function Main() {
    const {user, logoutUser} = useContext(AuthContext)

    // a temporary redirect to Mapper page
    const navigate = useNavigate()
    useEffect(() => {
                navigate(  `../mapper/projects/1`     )
    }, [])

    // uncomment the below after back to development of reports

    return (
            <></>
        // <div className="main-container">
        //
        //     <div className='top-bar'>
        //         <div>Main</div>
        //         {user &&  <div  style={{cursor: 'pointer'}} onClick={logoutUser}>Logout</div>}
        //     </div>
        //
        //     <BreadCrumbs user={user} itemsLinks={[{'name': 'Main', 'link': ''}, {'name': 'Applications', 'link': ''}]} />
        //
        //
        //     <div className="apps-container">
        //
        //         <NavLink to='mapper/projects/1'>
        //             <div className="one-app">
        //                 <div className="app-name">Icecat Mapper</div>
        //             </div>
        //         </NavLink>
        //
        //         <NavLink to='reports'>
        //             <div className="one-app">
        //                 <div className="app-name">Taxonomy Reports</div>
        //             </div>
        //         </NavLink>
        //
        //         <NavLink to='scripts'>
        //             <div className="one-app">
        //                 <div className="app-name">Custom Scripts</div>
        //             </div>
        //         </NavLink>
        //
        //     </div>
        //
        //     <Footer/>
        //
        // </div>

    )
}